module.exports = __webpack_public_path__ + "static/media/Pharynx.c11bf720.ogg";